import * as React from 'react';

export enum FiltreUserType {
    TOUS = 0,
    ADMIN = 1,
    SEMI_PRO = 2,
    MEMBER = 3,
    USER = 4,
}

export enum FieldSort {
    NOM_ASC,
    NOM_DES,
    PSEUDO_ASC,
    PSEUDO_DEC,
}

interface Props {
    setUserTypeFilter: (filtre: FiltreUserType) => void;
    userTypeFilter: FiltreUserType;
    setFieldSort: (sort: FieldSort) => void;
    userFieldSort: FieldSort;
}

interface State {
}

/**
 * Ce composant permet d'appliquer des filtres à la liste des utilisateurs
 */
export class UserFilter extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="row col-12">
                <div className=" row col-5" style={{float: 'right'}}>
                    <strong style={{marginTop: '34px', fontSize: '19px', marginRight: '20px'}}>
                        Filtrer:
                    </strong><this.FilterSelect />
                </div>
                <div className=" row col-6">
                    <strong style={{marginTop: '34px', fontSize: '19px', marginRight: '20px'}}>
                        Trier: </strong><this.SortSelect />
                </div>

            </div>
        );
    }

    private FilterSelect = () => {
        return (
            <select
                style={{marginTop: '30px', marginBottom: '30px'}}
                onChange={
                    (e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.props.setUserTypeFilter(Number.parseInt(e.currentTarget.value));
                    }
                }
                className="form-control col-6"
            >
                <option key={FiltreUserType.TOUS} value={FiltreUserType.TOUS.toString()}>
                    Tous
                </option>
                <option key={FiltreUserType.ADMIN} value={FiltreUserType.ADMIN.toString()}>
                    Administrateur
                </option>
                <option key={FiltreUserType.SEMI_PRO} value={FiltreUserType.SEMI_PRO.toString()}>
                    Semi-Pro
                </option>
                <option key={FiltreUserType.MEMBER} value={FiltreUserType.MEMBER.toString()}>
                    Membre
                </option>
                <option key={FiltreUserType.USER} value={FiltreUserType.USER.toString()}>
                    Utilisateur simple
                </option>
            </select>
        );
    }

    private SortSelect = () => {
        return (
            <select
                style={{marginTop: '30px', marginBottom: '30px'}}
                onChange={
                    (e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.props.setFieldSort(Number.parseInt(e.currentTarget.value));
                    }
                }
                className="form-control col-4"
            >
                <option key={FieldSort.NOM_ASC} value={FieldSort.NOM_ASC}>
                    Nom A-Z
                </option>
                <option key={FieldSort.NOM_DES} value={FieldSort.NOM_DES}>
                    Nom Z-A
                </option>
                <option key={FieldSort.PSEUDO_ASC} value={FieldSort.PSEUDO_ASC}>
                    Pseudo A-Z
                </option>
                <option key={FieldSort.PSEUDO_DEC} value={FieldSort.PSEUDO_DEC}>
                    Pseudo Z-A
                </option>
            </select>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/UserListPage/internalComponents/Filter.tsx